import { c as _c } from "react/compiler-runtime";
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { UserControllerRevokeSessionsMutationResponse, UserControllerRevokeSessionsPathParams, UserControllerRevokeSessionsQueryParams, UserControllerRevokeSessions403, UserControllerRevokeSessions404 } from "../../models/usersController/UserControllerRevokeSessions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { userControllerRevokeSessions } from "../../clients/usersService/userControllerRevokeSessions";
import { mutationOptions, useMutation } from "@tanstack/react-query";
export const userControllerRevokeSessionsMutationKey = () => [{
  url: '/api/v1/users/:userId/sessions/revoke'
}] as const;
export type UserControllerRevokeSessionsMutationKey = ReturnType<typeof userControllerRevokeSessionsMutationKey>;
export function userControllerRevokeSessionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const mutationKey = userControllerRevokeSessionsMutationKey();
  return mutationOptions<UserControllerRevokeSessionsMutationResponse, ResponseErrorConfig<UserControllerRevokeSessions403 | UserControllerRevokeSessions404>, {
    userId: UserControllerRevokeSessionsPathParams["userId"];
    params?: UserControllerRevokeSessionsQueryParams;
  }, TContext>({
    mutationKey,
    mutationFn: async ({
      userId,
      params
    }) => {
      return userControllerRevokeSessions(userId, params, config);
    }
  });
}

/**
 * @description Rejects every existing token for the user on its next use, signs them out of Cognito, revokes realtime tokens and expires their ProjectSight integrations within scope_id. Users may always revoke their own sessions; revoking another user requires admin rights over scope_id and the user must belong to it.
 * @summary Revoke all active sessions for a user
 * {@link /api/v1/users/:userId/sessions/revoke}
 */
export function useUserControllerRevokeSessions(t0) {
  const $ = _c(19);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const options = t1;
  let t2;
  if ($[2] !== options) {
    t2 = options ?? {};
    $[2] = options;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const {
    mutation: t3,
    client: t4
  } = t2;
  let t5;
  if ($[4] !== t3) {
    t5 = t3 === undefined ? {} : t3;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  const mutation = t5;
  let t6;
  if ($[6] !== t4) {
    t6 = t4 === undefined ? {} : t4;
    $[6] = t4;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const config = t6;
  let mutationOptions;
  let queryClient;
  if ($[8] !== mutation) {
    ({
      client: queryClient,
      ...mutationOptions
    } = mutation);
    $[8] = mutation;
    $[9] = mutationOptions;
    $[10] = queryClient;
  } else {
    mutationOptions = $[9];
    queryClient = $[10];
  }
  let t7;
  if ($[11] !== mutationOptions.mutationKey) {
    t7 = mutationOptions.mutationKey ?? userControllerRevokeSessionsMutationKey();
    $[11] = mutationOptions.mutationKey;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const mutationKey = t7;
  let t8;
  if ($[13] !== config) {
    t8 = userControllerRevokeSessionsMutationOptions(config);
    $[13] = config;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const baseOptions = t8 as UseMutationOptions<UserControllerRevokeSessionsMutationResponse, ResponseErrorConfig<UserControllerRevokeSessions403 | UserControllerRevokeSessions404>, {
    userId: UserControllerRevokeSessionsPathParams["userId"];
    params?: UserControllerRevokeSessionsQueryParams;
  }, TContext>;
  let t9;
  if ($[15] !== baseOptions || $[16] !== mutationKey || $[17] !== mutationOptions) {
    t9 = {
      ...baseOptions,
      mutationKey,
      ...mutationOptions
    };
    $[15] = baseOptions;
    $[16] = mutationKey;
    $[17] = mutationOptions;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return useMutation(t9, queryClient) as UseMutationResult<UserControllerRevokeSessionsMutationResponse, ResponseErrorConfig<UserControllerRevokeSessions403 | UserControllerRevokeSessions404>, {
    userId: UserControllerRevokeSessionsPathParams["userId"];
    params?: UserControllerRevokeSessionsQueryParams;
  }, TContext>;
}